import ProductNav from "../ProductNav/ProductNav";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <ProductNav />
      <div className="privacy-container">
        <h1>Privacy Policy</h1>

        <section>
          <h2>1. Introduction</h2>
          <p>
            We respect your privacy and are committed to protecting your
            personal information. This Privacy Policy explains how we collect,
            use, and safeguard your data when you use our website or services.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>Personal details such as name, email, and phone number.</li>
            <li>
              Usage data including pages visited and time spent on our site.
            </li>
            <li>Cookies and similar tracking technologies.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected data for purposes such as:</p>
          <ul>
            <li>Providing and improving our services.</li>
            <li>Sending updates, offers, or promotional materials.</li>
            <li>Ensuring website functionality and security.</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Protection</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal information from unauthorized access, misuse,
            or disclosure.
          </p>
        </section>

        <section>
          <h2>5. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at:{" "}
            <a href="mailto:support@invosys.co.in">support@invosys.co.in</a>
          </p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
